import type { MutableRefObject } from "react";

import type {
  Filter,
  OptimizedTaxonomyFilter,
} from "@shared/components/CatalogSearch/CatalogSearch";

interface Props {
  activeOptimizedTaxonomies: OptimizedTaxonomyFilter[];
  optimizedTaxonomySearchTags: MutableRefObject<OptimizedTaxonomyFilter[]>;
}

/**
 * The catalog pill tags for optimized taxonomies has additional logic
 * to determine if/how it should be displayed
 *
 * 1. The active optimized taxonomies are filtered to only include type "filter".
 * 2. If there is a corresponding "search" type to the "filter" type, we check if
 *    the "filter" tag should be visible.
 * 3. For each of the tag, we use the name from the "search" type if it exists
 */
const useOptimizedTaxonomyTags = ({
  activeOptimizedTaxonomies,
  optimizedTaxonomySearchTags,
}: Props) => {
  const optimizedTaxonomyTags: Filter[] = [];
  if (Array.isArray(activeOptimizedTaxonomies)) {
    const filterActiveOptimizedTaxonomies = activeOptimizedTaxonomies.filter(
      tax => tax.type === "filter"
    );
    for (const filterActiveOptTax of filterActiveOptimizedTaxonomies) {
      const optimizedFilterTag = optimizedTaxonomySearchTags?.current?.find(
        tag => tag?.id === filterActiveOptTax?.id
      );

      const hasSearchTags = optimizedTaxonomySearchTags?.current?.length;

      const isSearchTagVisible =
        optimizedFilterTag?.type === "search" && !optimizedFilterTag?.hideFromDisplay;

      if ((!optimizedFilterTag || isSearchTagVisible) && hasSearchTags) {
        optimizedTaxonomyTags.push({
          id: filterActiveOptTax.id,
          name: optimizedFilterTag?.name ?? filterActiveOptTax?.name,
          category: "OptimizedTaxonomy",
        });
      }
    }
  }

  return optimizedTaxonomyTags;
};

export { useOptimizedTaxonomyTags };
